class StatusCodes {
    static OK = 200;
    static INTERNAL_SERVER_ERROR = 500
    static REQUEST_TIMEOUT = 408
    static WAITING_FOR_RESPONSE = 418 
}

module.exports = StatusCodes;